import { OverlayRef } from "@angular/cdk/overlay";

export class SpinnerOverlayRef {
	constructor(private overlayRef: OverlayRef) { }

	public close(): void {
		this.overlayRef.dispose();
	}
}
